function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createMemoStyles } from '@wds/styles';
var menuButtonLineStyle = {
  position: 'absolute',
  height: '3px',
  width: '24px',
  background: '#fff',
  borderRadius: '2px',
  marginBottom: '6px',
  transition: 'all 0.4s'
};
var useMobileNavStyles = createMemoStyles(function (_ref) {
  var spacing = _ref.spacing;
  return {
    menuButton: function menuButton(props) {
      return _objectSpread(_objectSpread({
        position: 'absolute',
        top: '50%'
      }, props !== null && props !== void 0 && props.left ? {
        left: spacing[5]
      } : {
        right: spacing[5]
      }), {}, {
        transform: 'translateY(-50%)',
        height: '25px',
        width: '26px',
        borderRadius: 0,
        border: 'none',
        boxShadow: 'none',
        background: 'none',
        cursor: 'pointer'
      });
    },
    menuButtonLineTop: function menuButtonLineTop(_ref2) {
      var showMobileNav = _ref2.showMobileNav;
      return _objectSpread(_objectSpread({}, menuButtonLineStyle), {}, {
        top: '0px',
        transition: 'all 0.2s',
        opacity: showMobileNav ? 0 : 1
      });
    },
    menuButtonLineMiddleLeft: function menuButtonLineMiddleLeft(_ref3) {
      var showMobileNav = _ref3.showMobileNav;
      return _objectSpread(_objectSpread({}, menuButtonLineStyle), {}, {
        top: '10px',
        transform: showMobileNav ? 'rotate(225deg)' : null,
        width: showMobileNav ? '26px' : '24px'
      });
    },
    menuButtonLineMiddleRight: function menuButtonLineMiddleRight(_ref4) {
      var showMobileNav = _ref4.showMobileNav;
      return _objectSpread(_objectSpread({}, menuButtonLineStyle), {}, {
        top: '10px',
        transform: showMobileNav ? 'rotate(135deg)' : null,
        width: showMobileNav ? '26px' : '24px',
        opacity: showMobileNav ? 1 : 0
      });
    },
    menuButtonLineBottom: function menuButtonLineBottom(_ref5) {
      var showMobileNav = _ref5.showMobileNav;
      return _objectSpread(_objectSpread({}, menuButtonLineStyle), {}, {
        top: '20px',
        transition: 'all 0.2s',
        opacity: showMobileNav ? 0 : 1
      });
    }
  };
});
export default useMobileNavStyles;
//# sourceMappingURL=useStylesMenuButton.js.map